import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["textField", "player", "tempUrl"];

  connect() {
    const lexiconData = this.data.get("pronunciation-lexicon");
    this.pronunciationLexicon = lexiconData ? JSON.parse(lexiconData) : {};
    this.phoneticAlphabet = this.data.get("phonetic-alphabet") || "ipa";
  }

  applyPronunciationLexicon(text) {
    let result = text;
    for (const [word, phoneme] of Object.entries(this.pronunciationLexicon)) {
      const escaped = word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const regex = new RegExp(`\\b${escaped}\\b`, "gi");
      result = result.replace(
        regex,
        (match) => `<phoneme alphabet="${this.phoneticAlphabet}" ph="${phoneme}">${match}</phoneme>`
      );
    }
    return result;
  }

  async generateTempUrlBeforeSubmit(event) {
    const currentText = this.textFieldTarget.value;

    // If we've already generated the preview for this text, allow submission
    if (this.data.has("previewText") && this.data.get("previewText") == currentText) {
      // Clear the flag so it regenerates on next edit
      this.data.delete("previewText");
      return;
    }

    // Stop the Turbo submission so we can generate the preview first
    event.preventDefault();
    event.stopPropagation();

    await this.generatePreview();

    const form = this.textFieldTarget.closest("form");
    // Resume the Turbo fetch request
    form.requestSubmit();
  }

  async previewSpokenText(event) {
    event.preventDefault();
    event.stopPropagation();
    const link = event.target;
    if (link.classList.contains("disabled")) {
      return;
    }
    link.classList.add("disabled");
    await this.generatePreview();
    link.classList.remove("disabled");
    this.playPreview();
  }

  async generatePreview() {
    const rawText = this.textFieldTarget.value;
    this.data.set("previewText", rawText);
    if (rawText.length == 0) return null;

    const text = this.applyPronunciationLexicon(rawText);
    const response = await fetch(this.data.get("polly-url"), {
      body: JSON.stringify({ text: text }),
      method: "POST",
      mode: "cors",
      dataType: "json",
    });
    const data = await response.json();

    if (this.hasTempUrlTarget) {
      this.tempUrlTarget.value = data.url;
    }
    return data.url;
  }

  async generateAndSave(event) {
    event.preventDefault();
    const button = event.currentTarget;
    button.disabled = true;
    button.innerHTML = '<i class="spinner loading icon"></i> Generating Audio...';

    const url = await this.generatePreview();
    if (!url) {
      button.disabled = false;
      button.innerHTML = '<i class="volume up icon"></i> Generate Audio';
      return;
    }

    const form = this.element.closest("form");
    const tempUrlInput = form.querySelector('input[name="community_notification[temp_url]"]');
    if (tempUrlInput) tempUrlInput.value = url;

    const nextStepInput = form.querySelector('input[name="community_notification[next_step]"]');
    if (nextStepInput) nextStepInput.value = "voice_message";

    form.requestSubmit();
  }

  playPreview() {
    // alert(url)
    const audioPlayer = document.createElement("audio");
    this.playerTarget.innerHTML = "";
    audioPlayer.src = this.tempUrlTarget.value;
    audioPlayer.setAttribute("controls", "");
    this.playerTarget.appendChild(audioPlayer);
    audioPlayer.play();
  }
}
